/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { FeatureCardsSectionFragment } from "@cosmos/hygraph-schema";

import {
	ResponsiveContainer,
	SectionHeading,
	BackgroundContainer,
	SectionContainer,
	hasContent,
} from "@components/elements";
import { HeadingLevelContext, useCardHeadingOffset } from "@components/context";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { VStack } from "@panda/jsx";

import { FeatureCards } from "./FeatureCards.organism";

export const FeatureCardsSection = ({
	config,
	cards,
	tags,
	tagListTitle,
}: FeatureCardsSectionFragment): React.JSX.Element | null => {
	const cardOffset = useCardHeadingOffset(hasContent(config?.heading?.title));
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length || tags?.length || tagListTitle);
	if (!validHeading && !validContent) return null;

	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="feature-cards-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							// The TagList title renders h3; shift up to h2 when no section h2 title precedes it.
							<HeadingLevelContext.Provider value={{ offset: cardOffset }}>
								<FeatureCards cards={cards || []} tags={tags || []} tagListTitle={tagListTitle || ""} />
							</HeadingLevelContext.Provider>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
